import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "filterArray",
})
export class FilterPipe implements PipeTransform {
  transform(arrayToFilter: Array<any>, key: string, value: string) {
    if (arrayToFilter === null || arrayToFilter === undefined) {
      return arrayToFilter;
    }

    if (!key || !value) {
      return arrayToFilter;
    }

    const trimmedValue = value.trim().toLowerCase();

    const filter: any = {};
    key.split(",").forEach((k) => {
      const trimmedKey = k.trim();
      filter[trimmedKey] = trimmedValue;
    });

    return arrayToFilter.filter((obj) => {
      return Object.keys(filter).find((k) => {
        if (obj[k] !== null && obj[k] !== undefined) {
          return obj[k].toLowerCase().includes(filter[k]);
        }
        return false;
      });
    });
  }
}
